import './ReactCountdownClock.scss'
import { ComponentMapping, Container, ContainerState } from '@adobe/aem-react-editable-components'

import ReactCountdown from './ReactCountdown'
import { ReactCountdownClockProps } from './types'
import { getSpacing } from '../../utils/spacing-util'
import IsInEditorText from '../shared/IsInEditorText'
import { Accordion } from '../shared/ReactBootstrap'

class ReactCountdownClock extends Container<ReactCountdownClockProps, ContainerState> {
  constructor(props: ReactCountdownClockProps) {
    super(props)
    this.state = {
      componentMapping: this.props.componentMapping || ComponentMapping
    }
  }

  render() {
    const { isInEditor, defaultActive, id, countdownTarget, sticky = true, bottom = false, lob = '' } = this.props
    const defaultActiveKey = defaultActive ? '0' : undefined
    const stickyClass = sticky ? 'sticky' : ''

    if (!countdownTarget)
      return (
        <>
          {IsInEditorText(isInEditor, 'React Countdown Clock')}
          {IsInEditorText(
            isInEditor,
            'Please enter Countdown Target in Eastern Time in Format hh:mm:dd:yyyy - Hours (hh), Month (mm), Date (dd) and Year (yyyy)',
            '',
            true
          )}
        </>
      )

    return (
      <div
        data-testid='react-countdown-clock'
        className={`react-countdown-clock ${getSpacing(false, false, bottom, false)} ${stickyClass} ${lob}`}
        id={id}
      >
        {IsInEditorText(isInEditor, 'React Countdown Clock')}
        <Accordion className={`react-countdown-clock-accordion`} defaultActiveKey={defaultActiveKey} flush>
          <Accordion.Item eventKey={'0'}>
            <ReactCountdown {...this.props} childComponents={this.childComponents} />
          </Accordion.Item>
        </Accordion>
      </div>
    )
  }
}

export default ReactCountdownClock
